import Aside from "./AsideMob";

export default Aside;
